__turbopack_context__.v({
  "actions": "header-module-scss-module__In2oKa__actions",
  "root": "header-module-scss-module__In2oKa__root",
  "topbar_brand": "header-module-scss-module__In2oKa__topbar_brand",
  "wrapper": "header-module-scss-module__In2oKa__wrapper",
});
